/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PosReceiptResponseDto
 */
export interface PosReceiptResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PosReceiptResponseDto
     */
    receipt: string;
    /**
     * 
     * @type {string}
     * @memberof PosReceiptResponseDto
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof PosReceiptResponseDto
     */
    paymentReference?: string;
}

/**
 * Check if a given object implements the PosReceiptResponseDto interface.
 */
export function instanceOfPosReceiptResponseDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "receipt" in value;
    isInstance = isInstance && "orderReference" in value;

    return isInstance;
}

export function PosReceiptResponseDtoFromJSON(json: any): PosReceiptResponseDto {
    return PosReceiptResponseDtoFromJSONTyped(json, false);
}

export function PosReceiptResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PosReceiptResponseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'receipt': json['receipt'],
        'orderReference': json['orderReference'],
        'paymentReference': !exists(json, 'paymentReference') ? undefined : json['paymentReference'],
    };
}

export function PosReceiptResponseDtoToJSON(value?: PosReceiptResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'receipt': value.receipt,
        'orderReference': value.orderReference,
        'paymentReference': value.paymentReference,
    };
}

